import React, { useState, useEffect } from 'react';
import Header from './Header';
import Home from './Home';

function App() {
  const mobileMediaQuery = '(max-width: 767.98px)';
  const items = document.querySelectorAll('article');
  const [showOverlay, setShowOverlay] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [showMenu, setShowMenu] = useState(false);

  const setOverlay = (state) => {
    setShowOverlay(state);
  };

  const slideMenu = () => {
    const contents = document.querySelector('.inner-contents');
    if (showMenu) {
      contents.style.transform = 'translateX(0px)';
      setOverlay(false);
    } else {
      contents.style.transform = 'translateX(205px)';
      setOverlay(true);
    }
    setShowMenu(!showMenu);
  };

  //address bar to item url
  // const changeHistoryUrl = (item) => {
  //   const stateObj = { foo: 'bar' };
  //   window.history.pushState(
  //     stateObj,
  //     'x',
  //     item === null ? '/' : item.dataset.url
  //   );
  // };

  const openModal = (e) => {
    e.preventDefault();
    if (!showModal) {
      setOverlay(true);
      setShowModal(true);
      setCurrentItem(e.target.closest('.item'));
      //changeHistoryUrl(e.target.closest('.item'));
    }
  };

  const closeModal = () => {
    if (showModal) {
      setOverlay(false);
      setShowModal(false);
      setCurrentItem(null);
      //changeHistoryUrl(null);
    }
  };

  const toNextItem = () => {
    const itm =
      currentItem.nextSibling === null ? items[0] : currentItem.nextSibling;
    setCurrentItem(itm);
    //changeHistoryUrl(itm);
  };

  const toPreviousItem = () => {
    const itm =
      currentItem.previousSibling === null
        ? items[items.length - 1]
        : currentItem.previousSibling;
    setCurrentItem(itm);
    //changeHistoryUrl(itm);
  };

  const reset = () => {
    if (showOverlay) {
      if (isMobile && showModal) {
        closeModal();
      }
      if (isMobile && !showModal) {
        slideMenu();
      }
      if (!isMobile && showModal) {
        closeModal();
      }
      setOverlay(false);
    }
  };

  useEffect(() => {
    const query = window.matchMedia(mobileMediaQuery);
    const handleQueryChange = () => {
      query.matches ? setIsMobile(true) : setIsMobile(false);
    };
    window.addEventListener('load', handleQueryChange);
  }, [isMobile]);

  return (
    <div className='App'>
      <div
        className='inner-contents'
        style={{ position: isMobile && showModal ? 'fixed' : 'unset' }}
      >
        <div
          className='overlay'
          style={{ display: showOverlay ? 'flex' : 'none' }}
          onClick={reset}
        ></div>
        <Header isMobile={isMobile} />
        <Home
          slideMenu={slideMenu}
          isMobile={isMobile}
          showModal={showModal}
          currentItem={currentItem}
          openModal={openModal}
          closeModal={closeModal}
          toNextItem={toNextItem}
          toPreviousItem={toPreviousItem}
        />
      </div>
    </div>
  );
}
export default App;
